import { Injectable } from '@angular/core';
import { ApiBaseService } from './api.base.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class leadServices extends ApiBaseService {
  constructor(public http: HttpClient) {
    super(http, '/leads');
  }

  getReportData(params: any): Observable<any[]> {
    const data: any[] = [];
    return of(data);
  }

  getContacts(userId: number) {
    return this.http.get<any[]>(`${environment.apiUrl}/leads/`);
  }

  getPipeline(params) {
    return this.http.get<any[]>(`${environment.apiUrl}/leads/pipeline`, { params });
  }

  getPipelineByStepId(stepId, params) {
    return this.http.get<any[]>(`${environment.apiUrl}/leads/pipelineByStep/${stepId}`, { params });
  }

  exportData(body: any) {
    return this.http.post(`${environment.apiUrl}/leads/export`, body, { responseType: 'blob' });
  }

  closeLeads(body: any, force: boolean) {
    const queryString = force ? `?force=true` : '';
    return this.http.post(`${environment.apiUrl}/leads/closeLeads${queryString}`, body);
  }

  reAssignUsers(body: any, force: boolean) {
    const queryString = force ? `?force=true` : '';
    return this.http.post(`${environment.apiUrl}/leads/reAssign${queryString}`, body);
  }

  createNote(body: any) {
    return this.http.post(`${environment.apiUrl}/leads/bulkNote`, body);
  }

  searchLeads(data: any, query: string) {
    const queryString = query ? `?searchSring=${query}` : '';
    return this.http.post<any[]>(`${environment.apiUrl}/leads/search${queryString}`, data);
  }

  getDuplicate(email: string, phoneNumber: string, prefix, name, lastName) {
    const params = new HttpParams()
      .set('email', email)
      .set('phoneNumber', phoneNumber)
      .set('prefix', prefix)
      .set('name', name)
      .set('lastName', lastName);

    return this.http.get<any[]>(`${environment.apiUrl}/leads/duplicated`, { params });
  }

  resolveDuplicate(data: any, isMerged) {
    const queryString = isMerged ? `?isMerged=${isMerged}` : '';
    return this.http.put(`${environment.apiUrl}/leads/resolveDuplicate${queryString}`, data);
  }

  patchOwner(data: any, id: number) {
    return this.http.patch(`${environment.apiUrl}/leads/owners/${id}`, data);
  }

  patchGeneral(data: any, id: number) {
    return this.http.patch(`${environment.apiUrl}/leads/general/${id}`, data);
  }

  checkReopenDuplicates(id: number): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}/leads/check-reopen-duplicates/${id}`);
  }

  getLeadNavigation(leadId: number, lastRequest: any) {
    const params = { lastRequest: JSON.stringify(lastRequest) };
    return this.http.get<{ previousId: number | null; nextId: number | null }>(
      `${environment.apiUrl}/leads/navigation/${leadId}`,
      { params },
    );
  }

  sendCredentials(leadId: number): Observable<any> {
    return this.http.post(`${environment.apiUrl}/leads/${leadId}/send-credentials`, {});
  }

  validatePipelineForBulkStep(data: any): Observable<any> {
    return this.http.post(`${environment.apiUrl}/leads/validate-pipeline-bulk`, data);
  }

  bulkChangeStep(data: any): Observable<any> {
    return this.http.post(`${environment.apiUrl}/leads/bulk-change-step`, data);
  }

  markInboxAsSeen(leadId: number): Observable<{ success: boolean; markedCount: number; newInboxCount: number }> {
    return this.http.patch<{ success: boolean; markedCount: number; newInboxCount: number }>(
      `${environment.apiUrl}/inbox/leads/mark-seen/${leadId}`,
      {},
    );
  }

  markAsStarted(id: number): Observable<any> {
    return this.http.post(`${environment.apiUrl}/leads/${id}/mark-as-started`, {});
  }

  pushDate(id: number, data: { start_at: string; note?: string }): Observable<any> {
    return this.http.post(`${environment.apiUrl}/leads/${id}/push-date`, data);
  }

  markAsNotStarted(id: number, data: { lost_reason: number; lost_comment?: string; note?: string }): Observable<any> {
    return this.http.post(`${environment.apiUrl}/leads/${id}/mark-as-not-started`, data);
  }

  undoEnrollment(id: number): Observable<any> {
    return this.http.post(`${environment.apiUrl}/leads/${id}/undo-enrollment`, {});
  }

  updateFinancialAid(leadId: number, data: any) {
    return this.http.patch(`${environment.apiUrl}/leads/${leadId}/financial-aid`, data);
  }

  getFaConfig(): Observable<{
    faStatuses: any[];
    faOverallStatuses: any[];
    faDependencyTypes: any[];
    faVerificationStatuses: any[];
  }> {
    return this.http.get<any>(`${environment.apiUrl}/fa-config`);
  }

  uploadFafsaDocument(leadId: number, file: File): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post(`${environment.apiUrl}/leads/${leadId}/fafsa-document`, formData);
  }

  deleteFafsaDocument(leadId: number): Observable<any> {
    return this.http.delete(`${environment.apiUrl}/leads/${leadId}/fafsa-document`);
  }

  getFafsaDocumentUrl(leadId: number): Observable<{ url: string; name: string }> {
    return this.http.get<{ url: string; name: string }>(
      `${environment.apiUrl}/leads/${leadId}/fafsa-document-url`,
    );
  }
}